import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  showPopup: false,
  running: false,
  time: parseInt((new Date(2000, 0, 1, 0, 0, 0).getTime() / 1000).toFixed(0), 10),
  timePassed: 0
};

export function TimerReducer(
  state = { timers: [] },
  action
) {
  let currentTimer;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_TIMER" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("timers")
      ) {
        currentTimer =
          state.protocolSection.scene.apparatus.timers[
            findIndex(state.protocolSection.scene.apparatus.timers, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_TIMER":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("timers")) {
        protocolSection.scene.apparatus.timers = [
          ...protocolSection.scene.apparatus.timers,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.timers = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
    case "SET_TIMER_SHOW_POPUP":
      currentTimer = state.protocolSection.scene.apparatus.timers[action.payload.id-1];
      currentTimer.showPopup = action.payload.showPopup;

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
    case "SET_TIMER_RUNNING":
      currentTimer = state.protocolSection.scene.apparatus.timers[action.payload.id-1];

      if(currentTimer.running){
        currentTimer.timePassed += (currentTimer.time - 946677600);
      }

      currentTimer.running = !currentTimer.running;

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
    case "SET_TIMER_TIME":
      currentTimer = state.protocolSection.scene.apparatus.timers[action.payload.id-1];
      currentTimer.time = action.payload.time;

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
    case "ON_TIMER_CLICK_DONE":
      // currentTimer = state.protocolSection.scene.apparatus.timers[action.payload.id-1];
      // currentTimer.solution = action.payload.solution;

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('timers')) {
        protocolSection.scene.apparatus.timers =
          action.payload.lastState.scene.apparatus.timers;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
